/**
 * The RFC 7807 fields mesh-core writes in an error body. The fetch client's
 * `error.message` is only the HTTP status text, so a route's reason has to be
 * read from here.
 */
export type ProblemDetails = { title?: string; detail?: string };

export function problemDetails(
  error?: { body?: unknown } | null
): ProblemDetails {
  const body = error?.body;
  if (body === null || typeof body !== 'object') return {};
  const { title, detail } = body as Record<string, unknown>;
  return {
    title: typeof title === 'string' ? title : undefined,
    detail: typeof detail === 'string' ? detail : undefined,
  };
}

/** A write lost a race on the server and is safe to repeat. */
export const TRANSIENT_CONFLICT = 'transient_conflict';

/** The route's reason for a failed request, or `fallback`; never the HTTP status text. */
export function problemMessage(
  error: { body?: unknown } | null | undefined,
  fallback: string
): string {
  return problemDetails(error).detail || fallback;
}
